import React, { useEffect, useState } from "react";
import { Box, Button, Avatar, TextField, Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Tooltip from "@mui/material/Tooltip";
import { api } from "../../api/api";
import { StandadCard } from "../../components/Cards";
import { PageContainer } from "../../components/container/PageContainer";
import { DataTable } from "../../components/Table/DataTable";
import { CSVExportPlugin, RefreshPlugin } from "../../components/Table/plugins";
import { useAuth } from "../../contexts/AuthProvider/AuthProvider";
import { useMessagesPopup } from "../../contexts/MessagesPopupProvider/MessagesPopupProvider";
import { Breadcrumb } from "../../layout/fullLayout/breadcrumb/Breadcrumb";
import dayjs from "dayjs";

import { AspectRatio, Check, Edit, PendingActions, Visibility } from "@mui/icons-material";
import {
    MobileLogoRenderType,
    RenderType,
} from "../../components/Table/interfaces/IDataTableProps";

import moment from "moment";
import { useDateFilter } from "../../components/Table/hooks/useDateFilter";
import { CSVExportPluginonPagination } from "../../components/Table/plugins/CSVExportPlugin/CSVExportPluginonPagination";
import { ICSVDataFormat } from "../../components/Table/plugins/CSVExportPlugin/interfaces/ICSVExportPluginProps";
import { set } from "lodash";
import { ContextMenu } from "../../components/ContextMenu/ContextMenu";
import { IOffer } from "./interface/IOfffer";
import { ViewofferDailog } from "./offerDialog";
import { CreateOfferDialog, ICreateOfferDialog } from "./CreateOfferDialog";

export const Offer: React.FC = () => {
    const BCrumb = [
        {
            to: "/",
            title: "it-main",
        },
        {
            title: "Offer",
        },
    ];

    const [list, setList] = useState<IOffer[]>([]);
    const { date, type, handleDateSelectChange, dateDropdownList, setDate } =
        useDateFilter("", "last30Days");
    //when i select alltimes,it is not passing the alltime date to the api

    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState<string>("");

    const [tablePagination, setTablePagination] = React.useState({
        pageNumber: 1,
        rowsInPerPage: 25,
    });
    const [searchStatus, setSearchStatus] = React.useState<string>("ACTIVE");
    const [openView, setOpenView] = React.useState<IOffer | null>(
        null
    );

    const [totalRecords, setTotalRecords] = useState(0);
    const [openOffer, setOpenOffer] = useState<{
        open: boolean;
        mode: "create" | "edit";
        data: IOffer | null;
    }>({
        open: false,
        mode: "create",
        data: null,
    });
    const { showTopErrorSnackbar } = useMessagesPopup();
    const auth = useAuth();

    const fetchList = async () => {
        if (auth.user && auth.user.tokens) {
            try {
                setLoading(true);

                let apiURL = `/get-offer?pageNo=${tablePagination.pageNumber}&itemsPerPage=${tablePagination.rowsInPerPage}`;


                const res = await api.get(apiURL, {
                    headers: {
                        "auth-Token": auth.user.tokens.access,
                    },
                });

                setList(res.data.result ? res.data.result : []);
                setTotalRecords(res.data.totalRecords);
            } catch (err: any) {
                showTopErrorSnackbar(
                    err.response?.data?.msg || "Failed to fetch offer."
                );
            } finally {
                setLoading(false);
            }
        }
    };

    const fetchAllData = async () => {
        if (auth.user && auth.user.tokens) {
            try {
                let apiURL = `/get-offer?pageNo=${tablePagination.pageNumber}&itemsPerPage=${tablePagination.rowsInPerPage}`;


                const res = await api.get(apiURL, {
                    headers: {
                        "auth-Token": auth.user.tokens.access,
                    },
                });

                const data: ICSVDataFormat[] = res.data.result.map((item: any) => ({
                    ...item,
                    from_date: item.from_date
                        ? moment(item.from_date).format("YYYY-MM-DD")
                        : "--",
                    to_date: item.to_date
                        ? moment(item.to_date).format("YYYY-MM-DD")
                        : "--",
                }));
                return data; // Return the data fetched from the API
            } catch (error: any) {
                console.error("Error fetching data: ", error);
                showTopErrorSnackbar(
                    error.response?.data?.msg || "An error occurred while fetching data."
                );
                return []; // Return an empty array or handle as needed
            }
        } else {
            console.warn("User is not authenticated."); // Optional: Add warning if the user is not authenticated
            return []; // Return an empty array or handle as needed
        }
    };

    // const fetchPackages = async () => {
    //   try {
    //     const response = await api.get("/get-packages?vehicle_type=Four_Wheeler");
    //     setPackages(response.data.data);
    //   } catch (error) {
    //     console.error("Error fetching packages:", error);
    //   }
    // };

    useEffect(() => {
        fetchList();
    }, [tablePagination]);



    const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(event.target.value);
    };


    const memberTableProps = {
        isPagination: true,
        totalRecords: totalRecords,
        rowsPerPageOptions: tablePagination.rowsInPerPage,
        tableCommandBarProps: {
            leftItems: {
                customPlugins: [
                    //   {
                    //     key: "planAutoSearch",
                    //     onRender: () => (
                    //       <Box sx={{ minWidth: "250px" }}>
                    //         <PlanAutoSearch
                    //           onSelect={(value) => {
                    //             console.log(value);
                    //             setPackageName(value?.package_id ?? null);
                    //           }}
                    //         />
                    //       </Box>
                    //     ),
                    //   },
                    //   {
                    //     key: "byDate",

                    //     onRender: () => (
                    //       <DateFilterDropdown
                    //         value={type}
                    //         options={dateDropdownList}
                    //         onChange={handleDateSelectChange}
                    //       />
                    //     ),
                    //   },
                    //   {
                    //     key: "from_date",
                    //     onRender: () =>
                    //       type === "custom" ? (
                    //         <CustomDatePicker
                    //           sx={{ minWidth: "142px" }}
                    //           value={date.fromDate}
                    //           onChange={(newValue) => {
                    //             const newDate = moment(newValue).format("YYYY-MM-DD");
                    //             setDate({ ...date, fromDate: newDate });
                    //           }}
                    //         />
                    //       ) : (
                    //         <></>
                    //       ),
                    //   },
                    //   {
                    //     key: "to_date",
                    //     onRender: () =>
                    //       type === "custom" ? (
                    //         <CustomDatePicker
                    //           sx={{ minWidth: "142px" }}
                    //           value={date.toDate}
                    //           onChange={(newValue) => {
                    //             const newDate = moment(newValue).format("YYYY-MM-DD");
                    //             setDate({ ...date, toDate: newDate });
                    //           }}
                    //         />
                    //       ) : (
                    //         <></>
                    //       ),
                    //   },



                    {
                        key: "csvExport",
                        onRender: (columns: any, items: any) => (
                            <CSVExportPluginonPagination
                                columns={[
                                    {
                                        columnName: "offer_name",
                                        fieldName: "offer_name",
                                        width: 20,
                                    },
                                    {
                                        columnName: "offer_description",
                                        fieldName: "offer_description",
                                        width: 20,
                                    },

                                    {
                                        columnName: "offer_type",
                                        fieldName: "offer_type",
                                        width: 20,
                                    },

                                    {
                                        columnName: "image_url",
                                        fieldName: "image_url",
                                        width: 20,
                                    },
                                    {
                                        columnName: "order_no",
                                        fieldName: "order_no",
                                        width: 20,
                                    },
                                    {
                                        columnName: "package_id",
                                        fieldName: "package_id",
                                        width: 20,
                                    },
                                    {
                                        columnName: "status",
                                        fieldName: "status",
                                        width: 20,
                                    },
                                    {
                                        columnName: "insert_dt",
                                        fieldName: "insert_dt",
                                        width: 20,
                                    },

                                ]}
                                onExportButtonClick={fetchAllData}
                                filePrefixName="promoCode_details_Report"
                            />
                        ),
                    },
                    {
                        key: "refresh",
                        onRender: () => (
                            <RefreshPlugin
                                onClick={() => {
                                    fetchList();
                                }}
                            />
                        ),
                    },
                ],
            },
            rightItems: {
                plugins: {
                    searchField: {
                        searchKeys: [
                            "offer_name",
                            "offer_description",
                            "offer_type",
                            "image_url",
                            "order_no",
                            "package_id",
                            "status",
                            "insert_dt",
                        ],
                        items: list,
                    },
                },
                customPlugins: [
                    // {
                    //     key: "",
                    //     onRender: () => (
                    //         <Box sx={{ minWidth: "200px" }}>     <Button
                    //             variant="contained"
                    //             onClick={() =>
                    //                 setOpenCreate({ open: true, mode: "create", data: null })
                    //             }
                    //         >
                    //             Create Partner
                    //         </Button></Box>

                    //     ),
                    // },
                ],
            },
        },
        mobileLogo: {
            type: MobileLogoRenderType.reactNode,
            onMobileLogoRender: (data: any) => (
                <Avatar
                    sx={{ width: 45, height: 45, color: "#fff", ml: "-8px", mr: 2 }}
                ></Avatar>
            ),
        },
        columns: [
            {
                key: "actions",
                headerName: "Actions",
                fieldName: "",
                renderType: RenderType.CUSTOM_RENDER,
                onRowCellRender: (value: any, row: IOffer) => {
                    return (
                        <ContextMenu
                            menuOptions={[
                                {
                                    icon: <AspectRatio />,
                                    label: "See Details",
                                    onClick: () => setOpenView(row),
                                },
                            ]}
                        ></ContextMenu>
                    )

                },

            },
            {
                key: "offer_name",
                headerName: "Offer Name",
                fieldName: "offer_name",
                renderType: RenderType.TEXT,
            },
            {
                key: "offer_description",
                headerName: "Offer Description",
                fieldName: "offer_description",
                renderType: RenderType.TEXT,
            },
            {
                key: "offer_type",
                headerName: "Offer Type",
                fieldName: "offer_type",
                renderType: RenderType.TEXT,
            },
            {
                key: "image_url",
                headerName: "Image URL",
                fieldName: "image_url",
                renderType: RenderType.TEXT,
                onRowCellRender: (value: any, row: IOffer) => (
                    <img src={row.image_url} alt="Offer Image" width={100} height={100} />
                ),
            },
            {
                key: "order_no",
                headerName: "Order No",
                fieldName: "order_no",
                renderType: RenderType.TEXT,
            },
            {
                key: "package_id",
                headerName: "Package ID",
                fieldName: "package_id",
                renderType: RenderType.TEXT,
            },
            {
                key: "status",
                headerName: "Status",
                fieldName: "status",
                renderType: RenderType.TEXT,
                onRowCellRender: (value: any) => (
                    <Box>
                        {value.value === "ACTIVE" ? (
                            <Tooltip title="ACTIVE">
                                <Check color="success" />
                            </Tooltip>
                        ) : (
                            <Tooltip title="Pending">
                                <PendingActions color="warning" />
                            </Tooltip>
                        )}
                    </Box>
                ),
            },
            {
                key: "insert_dt",
                headerName: "Insert Date",
                fieldName: "insert_dt",
                renderType: RenderType.DATE,
            },
        ],
        items: list,
        onPageChange: (newPageNumber: number) => {
            setTablePagination({ ...tablePagination, pageNumber: newPageNumber });
        },
        onRowsPerPageChange: (pageNumber: number, rowsPerPage: number) => {
            setTablePagination({
                pageNumber: pageNumber,
                rowsInPerPage: rowsPerPage,
            });
        },
    };

    return (
        <PageContainer title="Offers" description="List of offers">
            <Breadcrumb title="Offers" items={BCrumb} />

            <StandadCard
                heading="Offers"
                rightHeading={
                    <Box sx={{ minWidth: "200px" }}>
                        {" "}
                        <Button
                            variant="contained"
                            onClick={() =>
                                setOpenOffer({ open: true, mode: "create", data: null })
                            }
                        >
                            Create Offer
                        </Button>

                    </Box>
                }
            >
                <DataTable {...memberTableProps} />
            </StandadCard>
            {openView && (
                <ViewofferDailog
                    open={!!openView}
                    offer={openView}
                    onClose={() => setOpenView(null)}
                />
            )}

            {openOffer.open && (
                <CreateOfferDialog
                    open={openOffer.open}
                    onClose={() => setOpenOffer(prev => ({ ...prev, open: false }))}
                    mode={openOffer.mode}
                    offer={openOffer.data as any}
                />
            )}
        </PageContainer>
    );
};

export default Offer;
